<template>
  <section>
    Erro 404
  </section>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>



// WEBPACK FOOTER //
// src/components/error/NotFound.vue